import { useEffect } from 'react';

export default function ViewportMeta({
  // 完全鎖縮放：不能放大/縮小（最穩定）
  content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
  // 若想允許放大可改成：
  // 'width=device-width, initial-scale=1, user-scalable=yes, maximum-scale=5, viewport-fit=cover'
}) {
  useEffect(() => {
    let tag = document.head.querySelector('meta[name="viewport"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'viewport');
      document.head.appendChild(tag);
    }
    const prev = tag.getAttribute('content') || '';
    tag.setAttribute('content', content);
    return () => { if (prev) tag.setAttribute('content', prev); };
  }, [content]);
  return null;
}
